module.exports = __webpack_public_path__ + "img/address.35d93ec5.svg";